'use client'
import React from 'react'
import { useRouter } from 'next/navigation'

export function useNavigateBack() {
  const { push, back } = useRouter()
  const [rootURL, setRootURL] = React.useState<string>('')
  const [fromLanding, setFromLanding] = React.useState<string | null>(null)

  React.useEffect(() => {
    setFromLanding(sessionStorage.getItem('fromLanding'))

    setRootURL(
      process.env.NEXT_PUBLIC_ENV === 'local'
        ? '/'
        : process.env.NEXT_PUBLIC_ENV === 'dev'
          ? 'https://www.dev.ddokso.com'
          : 'https://www.ddokso.com',
    )
  }, [])

  return {
    onClickBackButton: fromLanding ? () => back() : () => push(rootURL),
  }
}
